import React from 'react';
import Layout from './components/layout/app';
import { BrowserRouter } from 'react-router-dom'
import './styles/styles.css'

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;
